import { useState } from "react";

interface SelectedItem {
  _id: string;
  is_paid: boolean;
}

interface UseSelectApplicationsReturn {
  selectedIds: SelectedItem[];
  allSelected: boolean;
  someSelected: boolean;
  singleSelected: SelectedItem | null;
  toggleSelectAll: (checked: boolean, allIds: { _id: string; is_paid: boolean }[]) => void;
  toggleItem: (_id: string, is_paid: boolean) => void;
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isBulkAction: boolean;
  setIsBulkAction: React.Dispatch<React.SetStateAction<boolean>>;
  //   reset: () => void;
}

export const useSelectApplications = (defaultSelected: SelectedItem[] = []): UseSelectApplicationsReturn => {
  const [selectedIds, setSelectedIds] = useState<SelectedItem[]>(() => defaultSelected);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBulkAction, setIsBulkAction] = useState(false);
  const [singleSelected, setSelectedSingleApplication] = useState<SelectedItem | null>(null);

  const allSelected = defaultSelected.length > 0 && defaultSelected.every((item) => !!item.is_paid);
  const someSelected = defaultSelected.length > 0 && defaultSelected.some((item) => !!item.is_paid) && !allSelected;

  const toggleSelectAll = (checked: boolean, allIds: { _id: string; is_paid: boolean }[]) => {
    console.log("Toggling select all to:", checked, allIds);
    setSelectedIds(allIds.map((item) => ({ _id: item._id, is_paid: checked ? true : false })));
    setIsBulkAction(true);
  };

  const toggleItem = (id: string, is_paid: boolean) => {
    setSelectedSingleApplication({ _id: id, is_paid });
    setIsModalOpen(true);
  };

  // Reset selection
  //   const reset = useCallback(() => setSelectedIds([]), []);

  return {
    selectedIds,
    allSelected,
    someSelected,
    singleSelected,
    isModalOpen,
    setIsModalOpen,
    toggleSelectAll,
    toggleItem,
    isBulkAction,
    setIsBulkAction,
    // reset,
  };
};
